// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1O7W2","column":"style_column__3zPyr","row":"style_row__3sy4t"};